import React, { useEffect } from "react";
import SlugMessage from "./SlugMessage";
import TextInput from "./TextInput";
import slug from "slug";
import Heroicon from "../Heroicon";

function AddWebsite({
  websiteType,
  podcastData,
  handleChange,
  slugValidation,
  validWebsite,
  setValidWebsite,
}) {
  const validateWebsite = (value) => {
    handleChange("website", value);
    if (value !== "") {
      try {
        new URL(value);

        setValidWebsite(true);
      } catch (err) {
        setValidWebsite(false);
      }
    } else {
      setValidWebsite(true);
    }
  };

  // Assign podcast slug on mount
  useEffect(() => {
    if (!podcastData.podcast_slug && websiteType === "castos") {
      handleChange("podcast_slug", slug(podcastData.podcast_title));
    }
  }, []);

  const generateSlug = (value) => {
    // We want to allow people to type dashes at the end of the slug so we add { trim: false }
    // but this also allows adding a space at the beginning so we first trim the start before generating the slug
    const slugValue = slug(value.trimStart(), { trim: false });
    // We then remove any dashes at the start of the slug
    return slugValue.replace(/^-+/, "");
  };

  return (
    <>
      {websiteType === "castos" ? (
        <>
          <p className="mt-4 mb-6 text-sm text-gray-500">
            We create a custom website for each podcast on Castos. You can claim
            your unique sub-domain below. You can also link your own domain
            later in our dashboard.
          </p>
          <div className="grid grid-cols-[1fr,120px] sm:grid-cols-[1fr,150px] items-start">
            <TextInput
              value={podcastData.podcast_slug ?? ""}
              name={"podcast_slug"}
              title={"Castos Website"}
              handleChange={(e) =>
                handleChange("podcast_slug", generateSlug(e.target.value))
              }
              className="truncate"
            />
            <p className="px-3 py-2.5 border border-gray-300 border-l-0 rounded-md rounded-l-none text-center bg-gray-200 text-gray-500 text-sm">
              .castos.com
            </p>
          </div>
          <SlugMessage
            slugValidation={slugValidation}
            value={podcastData.podcast_slug}
            className="mt-2 mb-6 sm:mb-0"
          />
        </>
      ) : (
        <>
          <p className="mt-4 mb-6 text-sm text-gray-500">
            If you already have a website, or plan on creating one, which will
            contain all your podcast information and episodes, add that url
            below.
          </p>
          <TextInput
            value={podcastData.website}
            name={"website"}
            title={"Website"}
            handleChange={(e) => validateWebsite(e.target.value)}
          />
          {!validWebsite && podcastData.website.length > 0 && (
            <p className="flex items-center mt-2 text-sm text-red-600">
              <Heroicon icon="o-exclamation-circle" style="w-5 h-5 mr-1" />
              Please enter a valid website. For example: https://mysite.com
            </p>
          )}
        </>
      )}
    </>
  );
}

export default AddWebsite;
